import React from 'react';
import { portfolioData } from '../../../data/portfolio';

const Resume = () => {
    const { resumeUrl } = portfolioData;

    const handleResumeClick = () => {
        window.gtag('event', 'click', {
            'event_category': 'Document',
            'event_label': 'View Resume'
        });
    };

    return (
        <div className="w-full px-6 md:px-12 py-12 bg-gray-50/50" id="resume">
            <div className="w-full mx-auto">
                <div className="mb-12 relative pl-4 border-l-4 border-primary-500">
                    <h4 className="text-sm font-bold tracking-widest text-primary-600 uppercase mb-2 font-sans">MY RESUME</h4>
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 font-display">Download CV</h1>
                </div>

                <div className="flex flex-col md:flex-row items-center justify-between bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100">
                    <div className="mb-8 md:mb-0">
                        <h3 className="text-2xl font-bold text-gray-900 mb-2">Want to know more?</h3>
                        <p className="text-gray-600 text-lg">Download my resume to see my full work history and educational details.</p>
                    </div>

                    <a
                        href={resumeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleResumeClick}
                        className="inline-flex items-center px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white text-lg font-semibold rounded-xl transition-all duration-300 shadow-lg hover:shadow-primary-500/30 transform hover:-translate-y-1"
                    >
                        <span>View My Resume</span>
                        <svg className="w-6 h-6 ml-3" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Resume;
